<main
  class="flex w-full min-h-80vh pt-not-auth-header-m md:pt-not-auth-header-d justify-center items-center"
>
  <div class="md:mt-0 grow">
    <h2 class="text-center text-secondary font-semibold text-24px">
      {{ 'btn.login' | transloco }}
    </h2>

    <!-- autocomplete="off" -->
    <form
      [formGroup]="form"
      class="max-w-450px ml-auto mr-auto mt-36px px-app-x-m"
    >
      <ib-mat-form-field-wrap
        [formCtrlName]="'email'"
        [formCtrl]="form.get('email')"
        [showClearBtn]="true"
      >
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input
            matInput
            #emailInput
            formControlName="email"
            (keydown.enter)="submitFromInput($event)"
            name="email"
            required
            autocomplete="email"
          />
        </mat-form-field>
      </ib-mat-form-field-wrap>

      <ib-mat-form-field-wrap
        [formCtrlName]="'password'"
        [formCtrl]="form.get('password')"
        [htmlInputEl]="passw"
        class="mb-0!"
        [showPasswVisibilityBtn]="true"
      >
        <mat-form-field>
          <mat-label>{{ 'base.password' | transloco }}</mat-label>
          <input
            type="password"
            #passw
            matInput
            (keydown.enter)="submitFromInput($event)"
            autocomplete="current-password"
            formControlName="password"
            placeholder="{{ 'base.password' | transloco }}"
            name="password"
            required
          />
        </mat-form-field>
      </ib-mat-form-field-wrap>
      <div class="flex justify-end items-center mt-8px">
        <a
          mat-button
          class="ib-btn ib-btn-link ib-btn-secondary"
          [routerLink]="FORGOT_PASSW_ROUTE"
          >{{ 'btn.forgot-password' | transloco }}?</a
        >
      </div>
      <br />
      <footer class="mt-50px flex justify-center items-center">
        <ib-btn-wrap [isLoading]="loading">
          <button
            [disabled]="form.invalid || loading"
            mat-button
            type="button"
            (click)="login()"
            class="ib-btn-lg ib-btn-primary mx-auto w-220px"
          >
            {{ 'btn.login' | transloco }}
          </button>
        </ib-btn-wrap>
      </footer>
    </form>
  </div>
</main>
<ib-footer></ib-footer>
